import init from './init'
import sendEvent from './sendEvent'
import {setUserId} from './setUserId'
import setUserProperties from './setUserProperties'

const amplitude = {
  init,
  sendEvent,
  setUserId,
  setUserProperties
}

export default amplitude
